import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 180px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, styled } from "@mui/material";
export const CategoryListPageSkeletonItem = ()=>{
    return /*#__PURE__*/ _jsxs(SkeletonItemContainer, {
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 224,
                width: "100%"
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 26,
                width: 137,
                sx: {
                    marginTop: "8px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 48,
                width: "100%",
                sx: {
                    marginTop: "8px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 20,
                width: 64,
                sx: {
                    marginTop: "4px"
                }
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                height: 26,
                width: 144,
                sx: {
                    marginTop: "16px"
                }
            })
        ]
    });
};
export const SkeletonItemContainer = styled("div")(_templateObject());
